export default __webpack_public_path__ + "static/short-video-optimized-a67070f19770d5a9e20827a89e19402c.webm";